require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.5@core-js/library/modules/es7.symbol.observable.js
// module id = 500
// module chunks = 0